import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LogService {
  constructor() {}

  log(data: any) {}

  error(data: any) {
    console.error(data);
  }
}
